import styled from 'styled-components'
import variablesApplicationConfig from '../../../../variables'

const ContainerSectionTestimonialsCircular = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  margin-bottom: 50px;

  .middle-section {
    width: 100%;
    max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px;

    margin-top: 40px;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;

    position: relative;

    .m-s-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;

      margin-bottom: 80px;

      color: ${(props) =>
        props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};

      .label {
        font-weight: 700;
        font-size: 18px;
        font-family: var(--secondary-font-family);

        display: flex;
        align-items: center;

        svg {
          width: 50px !important;
          margin-top: 6px;
          margin-left: 10px;
        }
      }
      .title {
        width: 100%;
        max-width: 50%;
        font-size: 50px;
        line-height: 60px;
        font-weight: bold;
        margin-top: 10px;
        transition: all 0.6s ease-in-out;
        text-align: center;
        color: black;
      }
    }
    .m-s-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;

      .m-s-b-box-testimonial {
        width: 740px;

        background-color: white;

        border-radius: 20px;

        padding: 60px;

        .space-left {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .description {
          font-size: 18px;
          line-height: 32px;
          font-weight: 300;
        }
        .box-person {
          display: flex;
          margin-top: 40px;

          align-items: center;
          justify-content: space-between;

          flex-wrap: nowrap;

          .box-person-photo {
            width: 70px;
            height: 70px;
            background-color: rgba(0, 0, 0, 0.1);

            border-radius: 70px;
          }
          .box-person-data {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 20px;
            .fullName {
              font-size: 22;
              line-height: 30px;

              color: ${(props) =>
                props.color
                  ? 'var(--primary-color)'
                  : 'var(--secondary-color)'};
              font-weight: bold;
            }
            .personPosition {
              color: #727272;
              font-size: 16px;
              line-height: 26px;
            }
          }
        }

        .buttons-move {
          width: auto;
          gap: 20px;

          display: flex;
          margin-top: 40px;

          .button-left {
            width: 50px;
            height: 50px;

            border-radius: 50px;
            color: black;
            background-color: var(--background-color);
            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;
          }

          .button-right {
            width: 50px;
            height: 50px;
            border-radius: 50px;
            color: white;
            background-color: var(--primary-color);
            display: flex;
            align-items: center;
            justify-content: center;

            cursor: pointer;
          }
        }
      }
      .image {
        width: 500px;
        height: 480px;
        background-color: rgba(0, 0, 0, 0.1);
        position: absolute;
        right: 0;
        z-index: -1;
        border-radius: 20px;
      }
    }

    .button-action {
      display: flex;
      width: min-content;
      background-color: var(--primary-color);
      color: white;
      white-space: nowrap;

      margin-top: 120px;

      padding: 16px 26px 17px;

      border-radius: 100px;

      font-weight: 600;

      cursor: pointer;

      svg {
        font-size: 20px;
        margin-left: 10px;
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    .middle-section {
      margin-top: 0px !important;
      .m-s-top {
        .title {
          font-size: 30px;
          line-height: 40px;
        }
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    .middle-section {
      .m-s-top {
        .title {
          max-width: 86% !important;
        }
      }
      .m-s-bottom {
        .m-s-b-box-testimonial {
          width: 100%;
          margin: 0px 30px !important;

          padding: 30px 20px 20px;

          .description {
            font-size: 20px !important;
            line-height: 28px !important;
            text-align: center;
          }

          .space-left {
            display: flex !important;
            /* background-color: teal; */
            flex-direction: column;
          }

          /* .space-left {
            .box-person {
              .box-person-da
            }
          } */
        }
      }
    }
  }
`

export default ContainerSectionTestimonialsCircular
